import { useQuery } from '@tanstack/react-query';

import { PricingPlanChangeOptions } from 'src/features/stay/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/visitors/active-stay/:stayId/pricing-plan-change-options/';

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    stayId: string;
}

const queryFn = ({ parkingId, stayId }: DTO): Promise<PricingPlanChangeOptions> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, stayId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPricingPlanChangeOptions };
